import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiMailHelperService } from './mail-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiMailService {
  constructor(public hpr: ApiMailHelperService, private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('mail/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('mail/list', data);
  }

  create(data: any) {
    return this._api.post('mail/create', data);
  }

  update(data: any) {
    return this._api.post('mail/update', data);
  }

  remove(id: number) {
    return this._api.post('mail/remove/id/' + id);
  }
}
